import React, { useState, useEffect, useRef, Fragment } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer } from 'react-toastify';
import { ListsModal } from '../../contexts';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import { launchPhoneBurner } from '../../common/utils';

import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';

const Events = ( { aid, uid, user, viewing, canExport, stack, events, contacts } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [ eList, setEList ] = useState( [] );
    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );

    let cols = [
        { field: 'name', headerName: 'Name', width: 250, renderCell: ( params ) => <Link to={`/event/${params.row.id}`}>{params.value}</Link> },
        { field: 'status', headerName: 'Status', width: 100 },
        { field: 'date', headerName: 'Event Date', type: 'date', width: 100, valueGetter: ( { value } ) => value ? new Date( value ) : null, valueFormatter: ( { value } ) => value ? value.toLocaleDateString() : null },
        { field: 'start', headerName: 'Start Time', width: 100 },
        { field: 'end', headerName: 'End Time', width: 100 },
        { field: 'type', headerName: 'Type', width: 100 },
        { field: 'reg', headerName: 'Reg URL', width: 100 },
        { field: 'location', headerName: 'Location', width: 100 },
        { field: 'count', headerName: 'Members', width: 100 },
        { field: 'createdDate', headerName: 'Created', type: 'date', width: 100, valueGetter: ( { value } ) => value ? new Date( value ) : null, valueFormatter: ( { value } ) => value ? value.toLocaleDateString() : null },
        { field: 'lastChanged', headerName: 'Last Changed', type: 'date', width: 100, valueGetter: ( { value } ) => value ? new Date( value ) : null, valueFormatter: ( { value } ) => value ? value.toLocaleDateString() : null },
    ];
 
    const containerRef = useRef();
    const titleRef = useRef();
    const numbersRef = useRef();

    const gridRef = useGridApiRef();

    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center'>
                        <Col>
                            <Row className='text-start align-items-center'>
                                <Col xs='auto' className='pe-0'>
                                    <GridFooter className='tf-fake-footer' />
                                </Col>
                                <Col>
                                    { 
                                        selectedRows.length > 0 &&
                                        <Row style={ { borderLeft: '1px solid #CCC' } }>
                                            <Col xs='auto' className='pe-2'>Take Action...</Col>
                                            <Col xs='auto' className='ps-0'>
                                                <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent'>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'email-mass' ) }>Send Mass Email</Dropdown.Item>
                                                    {
                                                        hasTxting ? (
                                                            <Dropdown.Item onClick={ () => handleMassModal( 'sms-mass' ) }>Send Mass Txt</Dropdown.Item>
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                    <Dropdown.Divider />
                                                    {
                                                        hasPhoneBurner ? (
                                                            <Dropdown.Item onClick={ () => handleMassModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                </DropdownButton>
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col xs='auto' className='text-right'>
                            <GridToolbarQuickFilter />
                        </Col>
                        {
                            ( canExport ) ? (
                                <Col xs='auto' className='pe-3 text-right'>
                                    <GridToolbarExport />
                                </Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleMassModal = async ( t ) => {
        let shouldOpen = true;
        
        const cids = new Set();
        let cons = [];
        selectedRows.forEach( eid => {
            const e = events[eid];
            console.log( 'event: ', e );
            if ( e && e.members && e.members.length ) {
                e.members.forEach( m => {
                    cids.add( m.cid );
                    const c = contacts[m.cid];
                    if ( c ) {
                        cons.push( c );
                    }
                } );
            }
        } );

        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} clist={Array.from( cids )} objType='contact' /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} clist={Array.from( cids )} objType='contact' /> );
                break;

            case 'phoneburner':
                await launchPhoneBurner( aid, uid, Array.from( cids ), cons, stack.dialer );
                shouldOpen = false;
                break;

            default:
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    useEffect( () => {
        document.title = 'Third Floor - Events';
    }, [] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        console.log( 'events: ', events );
        let list = [];
        Object.keys( events ).forEach( eid => {
            const e = events[eid];
            if ( viewing.includes( e.aid ) ) {
                list.push( e );
            }
        } );
        setEList( list );
    }, [ events, viewing ] );

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>Events</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ListsModal.Provider value={ { openModal, closeModal, setModal } }>
                                        <DataGridPro
                                            apiRef={gridRef}
                                            getRowId={ ( row ) => row.eid }
                                            rows={eList}
                                            columns={cols}
                                            density='compact'
                                            checkboxSelection
                                            disableSelectionOnClick
                                            slots={ { toolbar: toolbar } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                        />
                                    </ListsModal.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    events: state.events.byId,
    contacts: state.contacts.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.events.loadEvents
} );
  
export default connect( mapProps, mapDispatch )( Events );